module.exports = __webpack_public_path__ + "static/media/hero__with-button.7fae51a8.png";